import { Pause, Play, X, Maximize2 } from 'lucide-react';
import { usePlayer, formatTime } from '@/contexts/PlayerContext';

export default function StickyPlayer() {
    const { track, playing, toggle, progress, duration, stop, fullscreen, setFullscreen } = usePlayer();
    if (!track || fullscreen) return null;

    const pct = duration ? Math.min(100, (progress / duration) * 100) : 0;

    return (
        <div
            className="fixed left-0 right-0 z-30 qm-glass border-t border-white/40 px-4 py-3 md:px-6"
            style={{ bottom: 'calc(env(safe-area-inset-bottom, 0) + 64px)' }}
            data-testid="sticky-player"
        >
            <div className="hidden md:block" style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} />
            <div className="max-w-6xl mx-auto flex items-center gap-3">
                {track.image ? (
                    <img src={track.image} alt="" className="w-10 h-10 rounded-xl object-cover" />
                ) : (
                    <div className="w-10 h-10 rounded-xl bg-sage" />
                )}
                <div className="min-w-0 flex-1">
                    <div className="text-sm font-medium text-forest truncate" data-testid="player-track-title">
                        {track.title}
                    </div>
                    <div className="h-1 mt-1.5 rounded-full bg-forest/10 overflow-hidden">
                        <div className="h-full bg-forest transition-[width] duration-300" style={{ width: `${pct}%` }} />
                    </div>
                </div>
                <span className="text-xs text-forest-soft tabular-nums hidden sm:inline">
                    {formatTime(progress)} / {formatTime(duration)}
                </span>
                <button
                    onClick={toggle}
                    aria-label={playing ? 'Pause' : 'Play'}
                    data-testid="player-toggle-button"
                    className="rounded-full w-10 h-10 grid place-items-center bg-forest text-cream hover:scale-105 active:scale-95 transition"
                >
                    {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
                </button>
                <button
                    onClick={() => setFullscreen(true)}
                    aria-label="Open full player"
                    data-testid="player-fullscreen-button"
                    className="rounded-full w-9 h-9 grid place-items-center text-forest hover:bg-sage/30 transition hidden sm:grid"
                >
                    <Maximize2 size={16} />
                </button>
                <button
                    onClick={stop}
                    aria-label="Close player"
                    data-testid="player-close-button"
                    className="rounded-full w-9 h-9 grid place-items-center text-forest hover:bg-dusty/40 transition"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
